<section class="component-tab component-faq">
	<div class="wrapper">
		<div class="row">
			<div class="col-12 col-md-9">
				<a href="javascript:void(0);" (click)="openIframeFormModal( dFormContent.insert_iframe )" class="btn btn-primary btn-circle"><span [innerHtml]="dFormContent.add_form_button_name"></span></a>
			</div>
		</div>
	</div>
</section>